import { isPro } from "@/server/config.js";
export const ELECTRONIC_PRIVACY_ID = isPro ? 'bd49391b80c747e89203dcc4e13420bb' : 'a6f9bfe3b7334e6d8f19c5024e85dcbd'